/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_Body_PlaceholderInputs */

const en_mail_compose_body_placeholder = /** @type {(inputs: Mail_Compose_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type here…`)
};

const de_mail_compose_body_placeholder = /** @type {(inputs: Mail_Compose_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier tippen…`)
};

/**
* | output |
* | --- |
* | "Type here…" |
*
* @param {Mail_Compose_Body_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_body_placeholder = /** @type {((inputs?: Mail_Compose_Body_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_Body_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_body_placeholder(inputs)
	return en_mail_compose_body_placeholder(inputs)
});